class Permissions {
    constructor() {
        this.write = null;
    }
}

export { Permissions };
